import React, { useState, useEffect } from "react";
import "../css/CookieConsent.css";

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if the user has already accepted cookies
        const cookiesAccepted = localStorage.getItem("cookiesAccepted");
        if (!cookiesAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem("cookiesAccepted", "false");
        setIsVisible(false);
    };

    if (!isVisible) return null; // Don't render if consent is already given

    return (
        <div className="cookie-banner">
            <p>
                We use cookies to enhance your experience. By continuing, you accept our{" "}
                <a target="_blank" href="https://www.goldcleats.com/privacy-policy/">Privacy Policy</a>.
            </p>
            <div className="cookie-buttons">
                <button className="btn btn-login" onClick={handleAccept}>Accept</button>
                <button className="btn btn-reject" onClick={handleReject}>Reject</button>
            </div>
        </div>

    );
};

export default CookieConsent;